<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>Auditions</h1>
        </div>
    </section>
  </div>

  <section class="section">
      <AuditionsRows :items="plays" />
  </section>

</div>
</template>

<script>
import AuditionsRows from './cards/AuditionsRows';
import Api from '@/config/Api'

export default {
    components: {
        AuditionsRows
    },
    data() {
        return {
            plays: []
        }
    },
    created() {
        Api().get(`/api/plays/opentoauditions`).then(response => {
            this.plays = response.data.plays;
            console.log("auditions created", this.plays);
            this.$store.commit('setContentLoaded', true); // then footer will be displayed
        });
    },
    metaInfo: {
      title: "Auditions",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
    
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/Auditions.vue